import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import img from '../assets/Images/patrick-tomasso-Oaqk7qqNh_c-unsplash.jpg';
import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import { Blogs } from '../data/BlogData';
import BlogComponent from './BlogComponent';
import AnchorComponent from '../subComponents/Anchor';
import BigTitle from '../subComponents/BigTitlte';
import { motion } from 'framer-motion';

const MainContainer = styled(motion.div)`
  background-image: url(${img});
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
`;

const Container = styled.div`
  background-color: ${(props) => `rgba(${props.theme.bodyRgba},0.8)`};
  width: 100%;
  height: auto;
  position: relative;
  padding-bottom: 5rem;
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10rem;

  @media (max-width: 768px) {
    padding-top: 7rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(calc(10rem + 15vw), 1fr));
  grid-gap: calc(1rem + 2vw);

  @media (max-width: 768px) {
    grid-template-columns: 100%;
    padding: 0 1rem;
  }
`;

const LogoWrapper = styled.div`
  position: fixed;
  top: 2rem;
  left: 2rem;
  z-index: 3;

  @media (max-width: 768px) {
    top: 1rem;
    left: 1rem;
  }
`;

const PowerButtonWrapper = styled.div`
  position: fixed;
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;

  @media (max-width: 768px) {
    top: 1rem;
  }
`;

const SocialIconsWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 2rem;
  z-index: 3;

  @media (max-width: 768px) {
    left: 1rem;
  }
`;

const BigTitleWrapper = styled.div`
  position: fixed;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  z-index: 0;

  @media (max-width: 768px) {
    font-size: calc(5rem + 5vw);
  }
`;

// Framer-motion config
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.5,
      duration: 0.5,
    },
  },
};

const BlogPage = () => {
  const [numbers, setNumbers] = useState(0);

  useEffect(() => {
    const updateNumbers = () => {
      let num = (window.innerHeight - 70) / 30;
      setNumbers(parseInt(num));
    };

    updateNumbers();
    window.addEventListener('resize', updateNumbers);

    return () => window.removeEventListener('resize', updateNumbers);
  }, []);

  return (
    <MainContainer
      variants={container}
      initial="hidden"
      animate="show"
      exit={{
        opacity: 0,
        transition: { duration: 0.5 },
      }}
    >
      <Container>
        <LogoWrapper>
          <LogoComponent />
        </LogoWrapper>
        <PowerButtonWrapper>
          <PowerButton />
        </PowerButtonWrapper>
        <SocialIconsWrapper>
          <SocialIcons />
        </SocialIconsWrapper>
        <AnchorComponent number={numbers} />
        <Center>
          <Grid>
            {Blogs.map((blog) => (
              <BlogComponent key={blog.id} blog={blog} />
            ))}
          </Grid>
        </Center>
        <BigTitleWrapper top="5rem" left="5rem">
          <BigTitle text="BLOG" />
        </BigTitleWrapper>
      </Container>
    </MainContainer>
  );
};

export default BlogPage;
